import React, { useState, useEffect, useCallback, useRef } from "react";

import moment from "moment";

import Modal from "react-bootstrap/Modal";
import Select from "react-select";
import { toast } from "react-toastify";

import crypto from "crypto";

import * as Constant from "../../../../Constant.js";
import axios from "@app/lib/axios";
import utility from "@app/lib/utility.js";

import InputGroup from "react-bootstrap/InputGroup";

import DatePicker from "react-datepicker";
import "./datepicker_custom.css";
import { ko } from "date-fns/esm/locale";

import tas4Style from "@app/pages/TAS4/Component/style";

import * as commonData from "@app/lib/common_data";
import { service } from "../../Stat/App/Momo/config.js";

const padding_num = 0;
const hasCellQuantity = (bizApp) => {
    return bizApp.info && bizApp.info.quantity && bizApp.info.quantity.type == 'single'; // 단독 원아 수 표시 시
};

const getBizAppMap = (bizApp, onChangeBizAppFold, expand = false) => {
    const today = moment();
    const endDate = moment().add(1, "year");
    if (today.get("month") >= 5) {
        endDate.add(1, "year");
    }
    const bizAppMap = {};
    Object.keys(bizApp).forEach((a) => {
        bizAppMap[a] = {
            start_date: today.format("YYYY-MM-01"),
            end_date: endDate.format("YYYY-02-01"),
            hasPreContractedBranch: bizApp[a].hasPreContractedBranch,
            count: 0,
            quantity: 0,
            fold: false,
            displayFold: false,
            info: bizApp[a].info,
            authTypeList: bizApp[a].authTypeList,
            onChangeBizAppFold: onChangeBizAppFold,
            hasCellQuantity: hasCellQuantity(bizApp[a]),
        };
        bizAppMap[a].colAdd = (bizAppMap[a].hasCellQuantity ? 1 : 0);
    });

    return bizAppMap;
};

const quantityPreHandler = (bizApp, list, idx, val, callback) => {
    // 신규 추가된 반인 경우
    if(!list[idx].id) {
        // 원아 정보가 없기 때문에 바로 원아 수 설정
        callback(true, val);
    } else {
        // 계약별로 추가된 원아 수보다 적은지 확인
        const subscriberId = list[idx].id;
        // 플라잉등 단독 원아 설정 확인
        const type = bizApp.quantity.type == 'union' ? bizApp.quantity.type : bizApp.key;

        if(list[idx].childsInfo && list[idx].childsInfo[type]) {
            quantityPreHandlerCallback(bizApp, list, idx, val, type, callback);
        } else {
            axios({
                method: "get",
                url: `${Constant.API_DOMAIN}/api/contract/child/${subscriberId}/${type}`,
            })
                .then((res) => {
                    if(res.data.code === 200) {
                        const registedChilds = res.data.registed;
                        if(!list[idx].childsInfo) {
                            list[idx].childsInfo = {};
                        }
                        list[idx].childsInfo[type] = registedChilds;
                        quantityPreHandlerCallback(bizApp, list, idx, val, type, callback);
                    } else {
                        console.log(res);
                        toast.error(res.data.msg);
                        callback(false, val);
                    }
                })
                .catch((error) => {
                    console.log(error);
                    console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
                    callback(false, val);
                });
        }
    }
};

const quantityPreHandlerCallback = (bizApp, list, idx, val, type, callback) => {
    let msg = [];
    list[idx].childsInfo[type].forEach((r) => {
        if(r.childCount > val) {
            msg.push(<><br />{`${r.appName}: ${r.childCount}명`}</>)
        }
    });
    if(msg && msg.length > 0) {
        toast.error(<><div style={{width: 350}}>서비스에 등록된 원아 수보다 적게 변경할 수 없습니다.</div><div>홈페이지에서 등록된 원아 수를 확인하세요.</div>{msg}</>, {autoClose: 4000});
        callback(false, val);
    } else {
        toast.dismiss();
        callback(true, val);
    }
};

const quantityHandler = (bizApp, list, idx, val, changeHandler) => {
    const _list = list;
    bizApp.quantity.field.forEach((f) => _list[idx][f] = val);
    changeHandler(_list);
};

const deviceHandler = (list, idx, val, changeHandler) => {
    const _list = list;
    const authIndex = _list[idx];
    authIndex.device = val;
    changeHandler(_list);
};

const unionHandler = (appAuthTypeList, list, idx, val, changeHandler) => {
    const _list = list;
    const authIndex = _list[idx];

    // 선택된 결합 상품이 있는 경우 다른 계약의 authType을 모두 null 처리하고 주계약의 authType을 업데이트 한다.
    authIndex.unionSelected = null;
    authIndex.unionId = null;
    Object.keys(authIndex.app_auth).forEach((k) => {
        authIndex.app_auth[k].authType = null;
        authIndex.app_auth[k].authTypeName = null;
    });

    const selected = val ? appAuthTypeList.all.find((at) => at.id == val) : null;
    if(selected) {
        authIndex.app_auth[selected.appId].authType = selected.type;
        authIndex.app_auth[selected.appId].authTypeName = selected.name;
        authIndex.unionSelected = selected;
        authIndex.unionId = val;
    }
    changeHandler(_list);
};
    
const startDateHandler = (app, list, idx, date, changeHandler) => {
    const _list = [...list];
    const authIndex = _list[idx].app_auth[app];
    authIndex.start_date = moment(date).format("YYYY-MM-01");
    changeHandler(_list);
};

const endDateHandler = (app, list, idx, date, changeHandler) => {
    if (list[idx].app_auth[app] && (list[idx].app_auth[app].approval === "AP" || list[idx].app_auth[app].approval === "WT")) {
        const _list = [...list];
        const authIndex = _list[idx].app_auth[app];
        authIndex.end_date = moment(date).format("YYYY-02-01");
        changeHandler(_list);
    }
};
const checkUnionUnbind = (app, list, idx) => {
    let checkUnionOk = true;
    let unbindUnionResult = false;
    // 결합 상품 여부 체크
    if(list[idx].unionSelected) {
        // 주계약 체크
        if(list[idx].unionSelected.appId == app) {
            checkUnionOk = false;
        }
        if(checkUnionOk) {
            // 서브 계약 항목이 없는 경우 path - 꾸러미결합의 경우 서브 목록없이 결합 상품만 존재
            if(list[idx].unionSelected.subList && list[idx].unionSelected.subList.length > 0) {
                const sub = list[idx].unionSelected.subList.find((s) => s.appId == app);
                if(sub) {
                    checkUnionOk = false;
                }
            }
        }
    }
    if(!checkUnionOk) {
        if(window.confirm("해당 서비스를 미사용 처리하시는 경우 결합 상품이 해지됩니다.\n미사용 처리하시겠습니까?")) {
            unbindUnionResult = true;
        }
    }
    return [checkUnionOk, unbindUnionResult];
};

const DefaultHeader = ({ bizApp, serviceAppList, appBranch, isView = false, onTransferContract }) => {
    useEffect(() => {
        return () => {};
    }, [bizApp, serviceAppList]);
    return (
        <thead className="table-contract-thead">
            {appBranch && (
                <tr className={"table-contract-tr-header"}>
                    <td colSpan="2" className="bg-dark text-center text-light font-bold table-contract-header table-contract-header-fixed">
                        지사명
                    </td>
                    <td colSpan="2" className="bg-dark table-contract-header bg-contract-header text-light text-center">
                    </td>
                    <td className={`bg-dark table-contract-header bg-contract-header text-center`}>
                    </td>
                    {serviceAppList ? (
                        serviceAppList.map((a) => {
                            if(a.contractUseTas && bizApp[a.key]) {
                                return (
                                    <td key={`table-header-transfer-${a.key}`} colSpan={a.colSpan} className="table-contract-header" style={{ backgroundColor: "#f5f6f9" }}>
                                        {Object.keys(appBranch[a.key]).map((k) => appBranch[a.key][k].name).join('/')}
                                        {onTransferContract && Object.keys(appBranch[a.key]).length > 0 && (
                                            <button className='btn btn-sm btn-outline-dark float-right' style={{padding: "1px 12px"}} onClick={() => onTransferContract(a.key)}>이관</button>
                                        )}
                                    </td>
                                );
                            }
                        })
                    ) : (
                        <></>
                    )}
                </tr>
            )}
            <tr className="table-contract-tr-header">
                <th className={`table-contract-header table-contract-header-fixed bg-dark text-light text-center`} style={{ minWidth: "110px" }} rowSpan="2">
                    계정
                </th>
                <th className={`table-contract-header table-contract-header-fixed bg-dark text-light text-center`} style={{ minWidth: "110px" }} rowSpan="2">
                    반명
                </th>
                <th className={`table-contract-header table-contract-header-fixed bg-contract-header-2 text-light text-center`} style={{ minWidth: "70px" }} rowSpan="2">
                    원아 수
                </th>
                <th className={`table-contract-header table-contract-header-fixed bg-contract-header-2 text-light text-center`} style={{ minWidth: "125px" }} rowSpan="2">
                    디바이스
                </th>
                <th className={`table-contract-header table-contract-header-fixed bg-union text-center`} style={{ minWidth: isView ? "150px" : "300px" }} rowSpan="2">
                    결합 {isView ? '상품' : '선택'}
                </th>
                {serviceAppList ? (
                    serviceAppList.map((a) => {
                        if(a.contractUseTas && bizApp[a.key]) {
                            return (
                                <th key={`table-header-${a.key}`} className={`table-contract-header bg-${a.key} text-light text-left font-bold`} colSpan={bizApp[a.key].fold ? 1 : 2 + bizApp[a.key].colAdd} style={{ minWidth: "130px" }}>
                                    {bizApp[a.key].info && bizApp[a.key].info.name}
                                    {bizApp[a.key].count >= 0 && <span className="ml-0">({bizApp[a.key].count})</span>}
                                    {bizApp[a.key].displayFold && <span>
                                        <i className={`table-contract-fold fas fa-${bizApp[a.key].fold ? "plus" : "minus"}-square`} onClick={() => bizApp[a.key].onChangeBizAppFold(a.key, bizApp)}></i>
                                    </span>}
                                </th>
                            );
                        } else {
                            return <></>;
                        }
                    })
                ) : (
                    <></>
                )}
            </tr>
            <tr>
                {serviceAppList ? (
                    serviceAppList.map((a) => {
                        if(a.contractUseTas && bizApp[a.key]) {
                            return (
                                <>
                                    <th className={`table-contract-header bg-${a.key}-70 text-center`} style={{ minWidth: "90px", maxWidth: "90px" }}>
                                        상태
                                    </th>
                                    {!bizApp[a.key].fold && (
                                        <>
                                            {bizApp[a.key].hasCellQuantity && (
                                                <th className={`table-contract-header bg-${a.key}-70 text-center`} style={{ minWidth: "80px", maxWidth: "80px" }}>
                                                    원아 수
                                                </th>
                                            )}
                                            <th className={`table-contract-header bg-${a.key}-70 text-center`} style={{ minWidth: "140px", maxWidth: "140px" }}>
                                                계약 기간
                                            </th>
                                        </>
                                    )}
                                </>
                            );
                        } else {
                            return <></>;
                        }
                    })
                ) : (
                    <></>
                )}
            </tr>
        </thead>
    );
};

const AddTableHeader = ({ bizApp, serviceAppList}) => {
    useEffect(() => {
        return () => {};
    }, [bizApp, serviceAppList]);
    return (
        <thead className="table-contract-thead">
            <tr className="table-contract-tr-header">
                <th className={`table-contract-header table-contract-header-fixed bg-dark text-light text-center`} style={{ minWidth: "110px" }} rowSpan="2">
                    계정
                </th>
                <th className={`table-contract-header table-contract-header-fixed bg-dark text-light text-center`} style={{ minWidth: "110px" }} rowSpan="2">
                    반명
                </th>
                <th className={`table-contract-header table-contract-header-fixed bg-contract-header-2 text-light text-center`} style={{ minWidth: "70px" }} rowSpan="2">
                    원아 수
                </th>
                <th className={`table-contract-header table-contract-header-fixed bg-contract-header-2 text-light text-center`} style={{ minWidth: "125px" }} rowSpan="2">
                    디바이스
                </th>
                <th className={`table-contract-header table-contract-header-fixed bg-union text-center`} style={{ minWidth: "300px" }} rowSpan="2">
                    결합 선택
                </th>
                {serviceAppList ? (
                    serviceAppList.map((a) => {
                        if(a.contractUseTas && bizApp[a.key]) {
                            const colSpan = bizApp[a.key].hasCellQuantity ? 2 : 1;
                            return (
                                <th key={`table-header-${a.key}`} className={`table-contract-header bg-${a.key} text-light text-left font-bold`} colSpan={colSpan} style={{ minWidth: "130px" }}>
                                    {bizApp[a.key].info && bizApp[a.key].info.name}
                                    {bizApp[a.key].count >= 0 && <span className="ml-0">({bizApp[a.key].count})</span>}
                                    {bizApp[a.key].displayFold && <span>
                                        <i className={`table-contract-fold fas fa-${bizApp[a.key].fold ? "plus" : "minus"}-square`} onClick={() => bizApp[a.key].onChangeBizAppFold(a.key, bizApp)}></i>
                                    </span>}
                                </th>
                            );
                        } else {
                            return <></>;
                        }
                    })
                ) : (
                    <></>
                )}
            </tr>
            <tr>
                {serviceAppList ? (
                    serviceAppList.map((a) => {
                        if(a.contractUseTas && bizApp[a.key]) {
                            return (
                                <>
                                    <th className={`table-contract-header bg-${a.key}-70 text-center`} style={{ minWidth: "90px", maxWidth: "90px" }}>
                                        사용
                                    </th>
                                    {bizApp[a.key].hasCellQuantity && (
                                        <th className={`table-contract-header bg-${a.key}-70 text-center`} style={{ minWidth: "80px", maxWidth: "80px" }}>
                                            원아 수
                                        </th>
                                    )}
                                </>
                            );
                        } else {
                            return <></>;
                        }
                    })
                ) : (
                    <></>
                )}
            </tr>
        </thead>
    );
};

const RecontractConfirmHeader = ({ bizApp, serviceAppList }) => {
    useEffect(() => {
        return () => {};
    }, [bizApp]);
    return (
        <thead className="table-contract-thead">
            <tr className="table-contract-tr-header">
                <th className={`table-contract-header table-contract-header-fixed bg-dark text-light text-center`} rowSpan="2">
                    반명
                </th>
                {serviceAppList ? (
                    serviceAppList.map((a) => {
                        if(a.contractUseTas && bizApp[a.key]) {
                            return (
                                <th className={`table-contract-header bg-${a.key} text-light text-center font-bold`} colSpan="2">
                                    {bizApp[a.key].info && bizApp[a.key].info.name}
                                </th>
                            );
                        }
                    })
                 ) : <></>}
            </tr>
            <tr>
                {serviceAppList ? (
                    serviceAppList.map((a) => {
                        if(a.contractUseTas && bizApp[a.key]) {
                            return (
                                <>
                                    <th className={`table-contract-header bg-${a.key}-70 text-center`}>계약 유지</th>
                                    <th className={`table-contract-header bg-${a.key}-70 text-center`}>재계약 수량</th>
                                </>
                            );
                        }
                    })
                 ) : <></>}
            </tr>
        </thead>
    );
};

const NullCell = (colSpan = 1) => {
    return <td style={{ backgroundColor: tas4Style.color.background.disabled, colSpan: colSpan}} />;
};

const DisabledCell = (colSpan = 1) => {
    return <td style={{ backgroundColor: tas4Style.color.background.disabled, colSpan: colSpan}} />;
};

const AgeStr = (age) => {
    if (age !== 123) {
        return `만${Number(age) + 2}세`;
    } else {
        return `혼합`;
    }
};

const getUnionId = (serviceAppList, appAuthTypeList, classAppAuth) => {
    let unionId = null;
    serviceAppList.find((a) => {
        if(a.contractUseTas) {
            if(classAppAuth[a.key] && (classAppAuth[a.key].approval == 'AP' || classAppAuth[a.key].approval == 'WT') && classAppAuth[a.key].authType && appAuthTypeList[a.key]) {
                const union = appAuthTypeList[a.key].find((at) => classAppAuth[a.key].authType == at.type);
                if(union) {
                    unionId = union.id;
                }
            }
        }
    });
    return unionId;
};

const getUnionInfo = (serviceAppList, appAuthTypeList, classAppAuth) => {
    serviceAppList.find((a) => {
        if(a.contractUseTas) {
            if(classAppAuth[a.key] && (classAppAuth[a.key].approval == 'AP' || classAppAuth[a.key].approval == 'WT') && classAppAuth[a.key].authType && appAuthTypeList[a.key]) {
                const union = appAuthTypeList[a.key].find((at) => classAppAuth[a.key].authType == at.type);
                if(union) {
                    return union;
                }
            }
        }
    });
    return null;
};

const getUnionName = (serviceAppList, appAuthTypeList, classAppAuth) => {
    let unionName = null;
    serviceAppList.find((a) => {
        if(a.contractUseTas) {
            if(classAppAuth[a.key] && (classAppAuth[a.key].approval == 'AP' || classAppAuth[a.key].approval == 'WT') && classAppAuth[a.key].authType && appAuthTypeList[a.key]) {
                const union = appAuthTypeList[a.key].find((at) => classAppAuth[a.key].authType == at.type);
                if(union) {
                    let hasAllUnion = true;
                    union.subList && union.subList.forEach((s) => {
                        if(!hasAllUnion || !classAppAuth[s.appId] || !(classAppAuth[s.appId].approval == 'AP' || classAppAuth[s.appId].approval == 'WT')) {
                            hasAllUnion = false;
                        }
                    });
                    if(hasAllUnion) unionName = union.name;
                }
            }
        }
    });
    return unionName;
};

const StatusStr = ({ approval, age, role }) => {
    if (role === "D") {
        if (approval === "AP") {
            return <span className="text-success">사용가능</span>;
        } else {
            return <span style={{ color: "#999" }}>사용불가</span>;
        }
    } else {
        let textColor = tas4Style.color.approval.normal[approval];
        let str = "승인대기";

        switch (approval) {
            case "AP":
                str = "승인";
                break;
            case "NA":
                str = "미사용";
                break;
            case "WT":
                str = "승인대기";
                break;
        }

        if (approval === "AP") {
            str = `${AgeStr(age)} ${str}`;
        }

        return <span style={{ color: textColor }}>{str}</span>;
    }
};

const ContractUserIdViewCell = ({ branchId, contract, serviceAppList, callback, onClassUpdate }) => {
    const [sId, setSId] = useState(0);
    const [data, setData] = useState(null);
    const [classNameNew, setClassNameNew] = useState(contract ? contract.class_name : "");
    const [pwdNew, setPasswordNew] = useState("");
    const [pwdNewRe, setPasswordNewRe] = useState("");
    const [updateResultMsg, setUpdateResultMsg] = useState(false);
    const timeout = useRef(null);
    const isBranch = utility.isRoleBranch();

    useEffect(() => {}, [contract, serviceAppList]);

    const contractHistoryCallback = () => {
        if (contract.is_new && !contract.is555) {
            return;
        }
        if (callback) {
            callback(contract.id, branchId);
        } else {
            axios({
                method: "get",
                url: `${Constant.API_DOMAIN}/api/contract/history/${branchId}/${contract.id}`,
            })
                .then((res) => {
                    const data = res.data;
                    const result = {};
                    // const terminate = {};
                    let year_set = new Set();
                    // if (res.data.terminate) {
                    //     res.data.terminate.forEach((t) => (terminate[t.app_id] = t.terminate_date));
                    // }
                    for (let h of data.history) {
                        let year = Number(moment(h.start_date).format("MM")) >= 6 ? Number(moment(h.start_date).format("YYYY")) + 1 : Number(moment(h.start_date).format("YYYY"));
                        // let terminateDate = terminate[h.app_id]
                        //     ? moment(terminate[h.app_id]).isBetween(moment(h.start_date), moment(h.end_date), undefined, "[]")
                        //         ? terminate[h.app_id]
                        //         : false
                        //     : false;
                        result[`${h.app_id}_${year}`] = h;
                        // result[`${h.app_id}_${year}`].terminate = terminateDate;
                        year_set.add(year);
                    }

                    data.result = result;
                    data.years = Array.from(year_set);

                    setSId(contract.id);
                    setData(res.data);
                })
                .catch((error) => {
                    console.log(error);
                    console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
                });
        }
    };

    const handleUpdateClassName = (e) => {
        e.preventDefault();
        if (!classNameNew || classNameNew.trim().length < 2 || classNameNew.trim().length > 16) {
            // setUpdateResultMsg("반 이름은 4~16자내로 입력해 주세요.");
            toast.info("반 이름은 2~16자내로 입력해 주세요.");
            return;
        }

        axios({
            method: "patch",
            url: `${Constant.API_DOMAIN}/api/class/${sId}`,
            data: {
                name: classNameNew,
                oldName: contract.class_name,
            },
        })
            .then((res) => {
                toast.success("반 정보를 변경하였습니다.");
                if (onClassUpdate) {
                    onClassUpdate({ name: classNameNew });
                }
            })
            .catch((error) => {
                console.log(error);
                console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
            });
    };

    const handleUpdatePassword = (e) => {
        e.preventDefault();
        if (!pwdNew || pwdNew.trim().length < 4 || pwdNew.trim().length > 16) {
            setUpdateResultMsg("비밀번호는 4~16자내로 입력해 주세요.");
            timeout.current = setTimeout(() => setUpdateResultMsg(""), 2500);
            return;
        }
        if (pwdNew != pwdNewRe) {
            setUpdateResultMsg("비밀번호가 일치하지 않습니다.");
            timeout.current = setTimeout(() => setUpdateResultMsg(""), 2500);
            return;
        }

        axios({
            method: "patch",
            url: `${Constant.API_DOMAIN}/api/subscriber/${sId}/password/change`,
            data: {
                pwdNew: crypto.createHash("md5").update(pwdNew.trim()).digest("hex"),
            },
        })
            .then((res) => {
                setUpdateResultMsg("비밀번호가 변경되었습니다.");
                timeout.current = setTimeout(() => setUpdateResultMsg(""), 2500);
            })
            .catch((error) => {
                console.log(error);
                console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
            });
    };

    const handleUpdateTestAccount = (e) => {
        e.preventDefault();

        axios({
            method: "patch",
            url: `${Constant.API_DOMAIN}/api/subscriber/${sId}/test/change`,
            data: {
                isTest: e.target.value,
            },
        })
            .then((res) => {
                toast.success(`계정 타입을 [${(res.data && res.data.isTest ? "테스트 계정" : "일반 계정")}]으로 변경하였습니다.`);
            })
            .catch((error) => {
                console.log(error);
                console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
            });
    };

    if(!serviceAppList) {
        return <></>;
    }

    const style = {
        color: contract.is_new && !contract.is555 ? "red" : "#71748d",
    };

    return (
        <>
            {contract.is_new && !contract.is555 ? (
                <span style={style}>(신규)</span>
            ) : (
                <a className={"a-user-id"} onClick={contractHistoryCallback}>
                    {contract.user_id}
                </a>
            )}
            <Modal
                size={"xl"}
                show={sId > 0}
                onHide={() => {
                    setSId(0);
                }}
                aria-labelledby="example-custom-modal-styling-title"
            >
                <Modal.Header closeButton>
                    <Modal.Title id="example-custom-modal-styling-title font-12">계약 정보</Modal.Title>
                </Modal.Header>
                {data && (
                    <Modal.Body style={{ overflow: "auto" }}>
                        <table className="table table-bordered" style={{ minWidth: "700px" }}>
                            <tbody>
                                <tr>
                                    <th className="bg-dark text-light" style={{ width: "110px" }}>
                                        계정
                                    </th>
                                    <td className="text-danger">
                                        <div className="row">
                                            <div className="col"><strong>{data.subscriber ? data.subscriber.user_id : "-"}</strong></div>
                                            {!isBranch && (
                                                <div className="col">
                                                    <select
                                                    className="form-control "
                                                    value={data.subscriber.isTest}
                                                    onChange={(e) => handleUpdateTestAccount(e)}
                                                    >
                                                        <option value={0}>일반 계정</option>
                                                        <option value={1}>테스트 계정</option>
                                                    </select>
                                                </div>
                                            )}
                                        </div>
                                        
                                    </td>
                                    <th className="bg-dark text-light" style={{width: "150px"}}>최초 등록일</th>
                                    <td className="">{data.subscriber ? data.subscriber.create_date : "-"}</td>
                                </tr>
                                {contract && contract.role !== "D" && (
                                    <tr>
                                        <th className="bg-dark text-light" style={{ width: "110px" }}>
                                            반 명
                                        </th>
                                        <td className="text-danger" colSpan={3}>
                                            <form autoComplete="off">
                                                <table className="" style={{ border: "0px", borderCollapse: "collapse", width: "100%" }}>
                                                    <tbody>
                                                        <tr>
                                                            <td className="text-right" style={{ border: "0px", width: "280px" }}>
                                                                <input
                                                                    name="classNameChange"
                                                                    type="text"
                                                                    autoComplete="off"
                                                                    className="form-control form-control-sm"
                                                                    value={classNameNew}
                                                                    onChange={(e) => setClassNameNew(e.target.value)}
                                                                />
                                                            </td>
                                                            <td className="text-left" style={{ border: "0px" }}>
                                                                <button className="btn btn-sm btn-primary btn-rounded" onClick={handleUpdateClassName}>
                                                                    저장
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </form>
                                        </td>
                                    </tr>
                                )}
                                <tr>
                                    <th className="bg-dark text-light" style={{ width: "110px" }}>
                                        비밀번호 변경
                                    </th>
                                    <td className="text-danger" colSpan={3}>
                                        <form autoComplete="off">
                                            <table className="" style={{ border: "0px", borderCollapse: "collapse", width: "100%" }}>
                                                <tbody>
                                                    <tr>
                                                        <td className="text-right" style={{ border: "0px", width: "110px" }}>
                                                            새로운 비밀번호
                                                        </td>
                                                        <td className="text-right" style={{ border: "0px", width: "170px" }}>
                                                            <input
                                                                name="pwdNew"
                                                                type="password"
                                                                autoComplete="off"
                                                                className="form-control form-control-sm"
                                                                value={pwdNew}
                                                                onChange={(e) => setPasswordNew(e.target.value)}
                                                            />
                                                        </td>
                                                        <td className="text-left text-danger" style={{ border: "0px", fontSize: "12px" }}>
                                                            {updateResultMsg}
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="text-right" style={{ border: "0px" }}>
                                                            비밀번호 확인
                                                        </td>
                                                        <td className="text-right" style={{ border: "0px" }}>
                                                            <input
                                                                name="pwdNewRe"
                                                                type="password"
                                                                autoComplete="off"
                                                                className="form-control form-control-sm"
                                                                value={pwdNewRe}
                                                                onChange={(e) => setPasswordNewRe(e.target.value)}
                                                            />
                                                        </td>
                                                        <td className="text-left" style={{ border: "0px" }}>
                                                            <button className="btn btn-sm btn-primary btn-rounded" onClick={handleUpdatePassword}>
                                                                저장
                                                            </button>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </form>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <table className="table table-bordered mt-1" style={{ minWidth: "700px" }}>
                            <tbody>
                                <tr>
                                    <th rowSpan={`${data.years.length + 1}`} className="bg-dark text-light" style={{ width: "110px" }}>
                                        계약 연차
                                    </th>
                                    {serviceAppList.map((a) => {
                                        if(a.contractUseTas) {
                                            return (
                                                <th className={`bg-${a.key} text-center text-light`} style={{ minWidth: "200px" }}>
                                                    {a.name}
                                                </th>
                                            );
                                        }
                                    })}
                                </tr>
                                {data.years.map((y, idx) => {
                                    return (
                                        <tr key={`table-contract-history-${idx}`}>
                                            {serviceAppList.map((a) => {
                                                if(a.contractUseTas) {
                                                    return (
                                                        <td className="text-center">
                                                            {data.result[`${a.key}_` + y] ? `${data.result[`${a.key}_` + y].start_date} ~ ${data.result[`${a.key}_` + y].end_date}` : `-`}
                                                            {data.result[`${a.key}_` + y] && data.result[`${a.key}_` + y].terminate && (
                                                                <>
                                                                    <br />
                                                                    <span className="text-danger">{`(${data.result[`${a.key}_` + y].terminate} 해지)`}</span>
                                                                </>
                                                            )}
                                                        </td>
                                                    );
                                                }
                                            })}
                                        </tr>
                                    );
                                })}

                                {(!data.years || data.years.length === 0) && (
                                    <tr>
                                        <td colSpan="4" className="text-center font-bold">
                                            해당 계약에 입력된 히스토리가 존재하지 않습니다.
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </Modal.Body>
                )}
            </Modal>
        </>
    );
};

const ContractDurationView = ({ approval, role, startDate, endDate, needRecontract }) => {
    if (needRecontract) {
        return <span className="text-danger">재계약 대상</span>;
    } else if (approval == "NA") {
        return null;
    } else if (role === "D") {
        return "-";
    }
    return (
        <>
            <ContractDateStr startDate={startDate} endDate={endDate} />
        </>
    );
};

const ContractDateStr = ({ startDate, endDate }) => {
    let textColor = "";
    const strStart = startDate ? moment(startDate).format("YYYY.MM") : "";
    const strEnd = endDate ? moment(endDate).format("YYYY.MM") : "";
    const str = strStart && strEnd ? `${strStart} ~ ${strEnd}` : "";
    return <span style={{ color: textColor }}>{str}</span>;
};

const CreateUseCheckboxSelect = ({ auth, auth_org, disabled, onChangeUseHandler }) => {
    useEffect(() => {
        return () => {};
    }, [auth]);

    const onChange = (e) => {
        onChangeUseHandler(e.target.checked);
    };
    return (
        <input type="checkbox" checked={auth == 'WT'} disabled={disabled} onChange={(e) => onChange(e)} />
    );
};

const AgeSelect = ({ bizApp, appId, approval, approval_org, canChangeNoAuth, age, authHandler, disabled, approvalTomonote }) => {
    const [value, setValue] = useState(approval);
    useEffect(() => {
        setValue(age);
        return () => {};
    }, [approval, age]);
    let ageArr = bizApp.age.list;

    let ageSelect = [];
    if (disabled || canChangeNoAuth || (canChangeNoAuth == false && (approval_org == "NA" || approval_org == "WT"))) {
        ageSelect.push({ label: "미사용", value: -1 });
    }
    ageArr.forEach((age) => {
        ageSelect.push({
            label: AgeStr(age),
            value: age,
        });
    });
    // 승인대기 계약 표시 텍스트 #5969ff
    const defaultValue = approval === "NA" ? ageSelect[0] : ageSelect.find((a) => a.value == value);
    const singleValueColor = disabled || approval_org == "WT" ? tas4Style.color.approval.disabled[approval_org] : tas4Style.color.approval.normal[approval];

    const onSelect = (e) => {
        const value = e.value;
        const result = {
            approval: "NA",
            age: Number(value),
        };
        if (value === -1) {
            result.approval = "NA";
            result.age = value;
        } else {
            result.approval = "AP";
            result.age = Number(value);
        }
        authHandler(result);
    };
    const style = {
        menu: (base) => ({
            ...base,
            marginTop: 2,
            zIndex: 9999,
        }),
        control: (base) => ({
            ...base,
            border: 0,
            color: "#5969ff",
            boxShadow: "none",
            backgroundColor: disabled ? tas4Style.color.background.disabled : tas4Style.color.background.normal.modal,
        }),
        singleValue: (provided) => ({
            ...provided,
            color: singleValueColor,
        }),
        dropdownIndicator: (base) => ({
            ...base,
            paddingLeft: 0,
            display: disabled ? "none" : "",
        }),
        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
    };
    return (
        <Select
            menuPortalTarget={document.body}
            options={ageSelect}
            defaultValue={defaultValue}
            value={defaultValue}
            defaultChecked={false}
            blurInputOnSelect={true}
            closeMenuOnSelect={true}
            isSearchable={false}
            isDisabled={disabled}
            components={{
                IndicatorSeparator: () => null,
            }}
            styles={style}
            onChange={onSelect}
        />
    );
};

const DeviceSelect = ({ approval, approval_org, device, onSelectHandler, disabled }) => {
    const [value, setValue] = useState(device);
    useEffect(() => {
        setValue(device);
        return () => {};
    }, [approval, device]);

    let deviceSelect = [{ label: "선택", value: null }, { label: "태블릿", value: "tablet" }, { label: "전자칠판", value: "board" }];
    
    // 승인대기 계약 표시 텍스트 #5969ff
    const defaultValue = !approval ? deviceSelect[0] : deviceSelect.find((a) => a.value == value);
    const singleValueColor = disabled || approval_org ? tas4Style.color.approval.disabled.AP : tas4Style.color.approval.normal.AP;

    const onSelect = (e) => {
        const value = e.value;
        onSelectHandler(value);
    };
    const style = {
        menu: (base) => ({
            ...base,
            marginTop: 2,
            zIndex: 9999,
        }),
        control: (base) => ({
            ...base,
            border: 0,
            color: "#5969ff",
            boxShadow: "none",
            backgroundColor: disabled ? tas4Style.color.background.disabled : tas4Style.color.background.normal.modal,
        }),
        singleValue: (provided) => ({
            ...provided,
            color: singleValueColor,
        }),
        dropdownIndicator: (base) => ({
            ...base,
            paddingLeft: 0,
            display: disabled ? "none" : "",
        }),
        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
    };
    return (
        <Select
            menuPortalTarget={document.body}
            options={deviceSelect}
            defaultValue={defaultValue}
            value={defaultValue}
            defaultChecked={false}
            blurInputOnSelect={true}
            closeMenuOnSelect={true}
            isSearchable={false}
            isDisabled={disabled}
            components={{
                IndicatorSeparator: () => null,
            }}
            styles={style}
            onChange={onSelect}
        />
    );
};

const QuantityInput = ({ auth, value, min = 0, max = Constant.CONTRACT_LIMIT.QUANTITY.BRANCH, quantityPreHandler, quantityHandler, disabled, lock }) => {
    const [quantity, setQuantity] = useState(value);
    const [quantityStr, setQuantityStr] = useState(value);
    useEffect(() => {
        setQuantity(value || 0);
        if (auth == "NA") {
            setQuantityStr("");
        } else {
            setQuantityStr(value || 0);
        }
        return () => {};
    }, [auth, value, disabled]);
    const onFocusQuantity = (e) => {
        setQuantityStr(quantityStr && quantityStr != 0 ? quantityStr : "");
    };
    const onBlurQuantity = useCallback(
        (e) => {
            let newQuantity = auth != "NA" && quantity > 0 ? (quantity < max ? quantity : max) : 0;
            try{
                newQuantity = parseInt(newQuantity);
            } catch(exception) {
                newQuantity = 0;
            }
            if(newQuantity != value) {
                quantityPreHandler(newQuantity, (isOk, val) => {
                    if(isOk) {
                        setQuantityStr(newQuantity > 0 ? newQuantity.toString() : "");
                        quantityHandler(newQuantity);
                    } else {
                        setQuantity(value);
                        setQuantityStr(value);
                    }
                });
            }
        },
        [quantity]
    );
    const onChangeQuantity = (e) => {
        const newQuantity = parseInt(e.target.value, 10);
        const limitedQuantity = newQuantity > max ? max : newQuantity;
        setQuantityStr(limitedQuantity.toString());
        setQuantity(limitedQuantity);
        if (newQuantity > max) {
            toast.error(`입력 가능한 최대 원아 수는 [${max}명]입니다.`);
        }
    };
    const backgroundColor = disabled ? tas4Style.color.background.disabled : tas4Style.color.background.normal.modal;
    return (
        <input
            style={{ height: "calc(2.25rem + 2px)", backgroundColor: backgroundColor }}
            type="number"
            className="form-control border-0"
            name="value"
            value={quantityStr}
            onChange={onChangeQuantity}
            onFocus={onFocusQuantity}
            onBlur={onBlurQuantity}
            disabled={disabled || lock}
            min={min}
            max={max}
        />
    );
};

const UnionSelect = ({ classAuth, union, appAuthTypeList, onSelectHandler, disabled }) => {
    const [value, setValue] = useState(union);
    useEffect(() => {
        setValue(union);
        return () => {};
    }, [classAuth, union]);

    let unionSelect = [{ label: "결합 없음", value: null }];
    
    appAuthTypeList.all.forEach((at) => {
        if(classAuth[at.appId] && (classAuth[at.appId].approval == 'AP' || classAuth[at.appId].approval == 'WT')) {
            let hasAllUnionSub = true;
            if(at.subList && at.subList.length > 0) {
                at.subList.forEach((s) => {
                    // 부계약 모두 승인 인 경우 선택 가능한 결합 상품 목록에 추가
                    if(hasAllUnionSub && !(classAuth[s.appId] && (classAuth[s.appId].approval == 'AP' || classAuth[s.appId].approval == 'WT'))) {
                        hasAllUnionSub = false;
                    }
                });
            }
            if(hasAllUnionSub) {
                unionSelect.push({label: `${at.name}${at.description ? ` (${at.description})` : ''}`, value: at.id});
            }
        }
    });
    const defaultValue = !union ? unionSelect[0] : unionSelect.find((a) => a.value == value);
    
    const onSelect = (e) => {
        const value = e.value;
        onSelectHandler(value);
    };
    const style = {
        menu: (base) => ({
            ...base,
            marginTop: 2,
            zIndex: 9999,
        }),
        control: (base) => ({
            ...base,
            border: 0,
            boxShadow: "none",
        }),
        singleValue: (provided) => ({
            ...provided,
        }),
        dropdownIndicator: (base) => ({
            ...base,
            paddingLeft: 0,
        }),
        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
    };
    return (
        <Select
            menuPortalTarget={document.body}
            options={unionSelect}
            defaultValue={defaultValue}
            value={defaultValue}
            defaultChecked={false}
            blurInputOnSelect={true}
            closeMenuOnSelect={true}
            isSearchable={false}
            isDisabled={disabled}
            components={{
                IndicatorSeparator: () => null,
            }}
            className={disabled ? 'text-gray' : 'text-union'}
            styles={style}
            onChange={onSelect}
        />
    );
};

const DurationCell = ({ startDate, endDate, yearFormat = 'yy', width = '170px', startDateHandler, endDateHandler, disabled, isMaster }) => {
    useEffect(() => {
        return () => {};
    }, [startDate, endDate]);

    if (startDate == null || endDate == null) {
        return null;
    }

    const backgroundColor = disabled ? tas4Style.color.background.disabled : tas4Style.color.background.normal.modal;
    return (
        <div className="row" style={{ minWidth: width, maxWidth: width, margin: 'auto' }}>
            <div className="col-5 pr-0 text-center">
                <DatePicker
                    className="form-control text-center border-0"
                    selected={startDate}
                    onChange={(date) => {
                        if (startDateHandler) startDateHandler(date);
                    }}
                    popperProps={{ positionFixed: true }}
                    selectsStart
                    startDate={startDate}
                    endDate={endDate}
                    dateFormat={`${yearFormat}-MM`}
                    showMonthYearPicker
                    disabled={startDateHandler === null || startDateHandler === undefined}
                    yearItemNumber={6}
                    locale={ko}
                />
            </div>
            <div className="col-2 pl-0 pr-0">
                <div className="form-control border-0 text-center" style={{ backgroundColor: backgroundColor, padding: "10px" }}>
                    ~
                </div>
            </div>
            <div className="col-5 pl-0">
                <DatePicker
                    className="form-control text-center border-0"
                    selected={endDate}
                    onChange={(date) => {
                        if (endDateHandler) endDateHandler(date);
                    }}
                    popperProps={{ positionFixed: true }}
                    selectsEnd
                    startDate={startDate}
                    endDate={endDate}
                    minDate={moment(startDate).get("month") >= 5 ? new Date(moment(startDate).add(1, "year").format("YYYY-MM-01")) : startDate}
                    dateFormat={`${yearFormat}-02`}
                    showYearPicker
                    popperPlacement="bottom-end"
                    disabled={disabled}
                    yearItemNumber={6}
                    locale={ko}
                />
            </div>
        </div>
    );
};

const CommonViewCell = ({ bizApp, age, quantity, auth, is555, role, needRecontract }) => {
    if(!bizApp || bizApp.length < 1 || !bizApp.info) {
        return <></>;
    }
    const addCellQuantity = hasCellQuantity(bizApp);    // 단독 원아 수 표시 시
    if((is555 && role != "D") || bizApp.info.age.list.indexOf(age) < 0) {
        return (
            <>
                <DisabledCell />
                <DisabledCell />
                {addCellQuantity && <NullCell />}
            </>
        );
    }
    if (!auth) {
        return (
            <>
                <td className={`table-contract-td table-contract-td-view p-${padding_num}`} style={{ textAlign: "center", backgroundColor: tas4Style.color.background.disabled, whiteSpace: "nowrap" }}>
                    <StatusStr approval={"NA"} />
                </td>
                <NullCell />
                {addCellQuantity && <NullCell />}
            </>
        );
    }

    const backgroundColor = auth.approval == "AP" ? tas4Style.color.background.normal.view : tas4Style.color.background.disabled;
    return (
        <>
            <td className={`table-contract-td table-contract-td-view p-${padding_num}`} style={{ backgroundColor: backgroundColor, whiteSpace: "nowrap" }}>
                <StatusStr approval={auth.approval} age={age} role={role} />
            </td>
            {addCellQuantity && 
                <td className={`table-contract-td table-contract-td-view p-${padding_num}`} style={{ backgroundColor: backgroundColor, whiteSpace: "nowrap" }}>
                    {auth.approval == "NA" ? "" : quantity}
                </td>
            }
            <td className={`table-contract-td table-contract-td-view p-${padding_num}`} style={{ backgroundColor: backgroundColor, whiteSpace: "nowrap" }}>
                <ContractDurationView approval={auth.approval} startDate={auth.start_date} endDate={auth.end_date} needRecontract={needRecontract} role={role} />
            </td>
        </>
    );
};

const CommonCreateCell = ({ bizApp, age, auth, auth_org, disabled, quantity, quantityMax = Constant.CONTRACT_LIMIT.QUANTITY.BRANCH, authHandler, quantityPreHandler, quantityHandler, is555 }) => {
    useEffect(() => {
        return () => {};
    }, [bizApp, age, auth]);
    if(!bizApp || bizApp.length < 1 || !bizApp.info) {
        return <></>;
    }

    const addCellQuantity = hasCellQuantity(bizApp);    // 단독 원아 수 표시 시

    if (!auth) {
        return (
            <>
                <NullCell />
                {addCellQuantity && <NullCell />}
            </>
        );
    }
    const backgroundColor = disabled ? tas4Style.color.background.disabled : tas4Style.color.background.normal.modal;

    return (
        <>
            <td className={`table-contract-td table-contract-td-create p-${padding_num} bg-union-70`} style={{ textAlign: "center", backgroundColor: backgroundColor,  }}>
                {disabled ? (
                    <AgeSelect bizApp={bizApp.info} appId={bizApp.info.appId} age={age} approval={auth} approval_org={auth_org} disabled={disabled} />
                ) : (
                    <CreateUseCheckboxSelect
                        bizApp={bizApp}
                        auth={auth}
                        auth_org={auth_org}
                        disabled={disabled}
                        onChangeUseHandler={(val) => {
                            authHandler(val);
                        }}
                    />
                )}
            </td>
            {addCellQuantity && 
                <td className={`table-contract-td table-contract-td-confirm p-${padding_num}`} style={{ textAlign: "left", backgroundColor: backgroundColor }}>
                    <QuantityInput auth={auth} age={age} is555={is555} max={quantityMax} value={quantity} quantityPreHandler={quantityPreHandler} quantityHandler={quantityHandler} disabled={disabled} lock={auth == "NA"} />
                </td>
            }
        </>
    );
};

const CommonConfirmCell = ({
    bizApp,
    age,
    quantity,
    quantityMax = Constant.CONTRACT_LIMIT.QUANTITY.BRANCH,
    auth,
    auth_org,
    authType,
    authTypeList,
    canChangeNoAuth = true,
    showChangeDuration = true,
    startDate,
    endDate,
    authHandler,
    authTypeHandler,
    startDateHandler,
    endDateHandler,
    quantityPreHandler,
    quantityHandler,
    disabled,
    is555,
    needRecontract,
    recontractHandler,
    recontractEndDate,
    fold = false,
}) => {
    useEffect(() => {
        return () => {};
    }, [bizApp, age, auth, authType, quantity, startDate, endDate, fold]);
    if(!bizApp || bizApp.length < 1 || !bizApp.info) {
        return <></>;
    }
    const addCellQuantity = hasCellQuantity(bizApp);    // 단독 원아 수 표시 시
    if (is555) {
        return (
            <>
                <DisabledCell />
                {!fold && (
                    <>
                        <DisabledCell />
                        {addCellQuantity && <DisabledCell />}
                    </>
                )}
            </>
        );
    } else if (!auth) {
        return (
            <>
                <NullCell />
                {!fold && (
                    <>
                        <NullCell />
                        {addCellQuantity && <NullCell />}
                    </>
                )}
            </>
        );
    }
    const backgroundColor = disabled ? tas4Style.color.background.disabled : tas4Style.color.background.normal.modal;
    return (
        <>
            <td className={`table-contract-td table-contract-td-confirm p-${padding_num}`} style={{ textAlign: "left", backgroundColor: backgroundColor }}>
                <AgeSelect bizApp={bizApp.info} appId={bizApp.info.appId} age={age} approval={auth} approval_org={auth_org} canChangeNoAuth={canChangeNoAuth} authHandler={authHandler} disabled={disabled} />
            </td>
            {!fold && (
                <>
                    {addCellQuantity && 
                        <td className={`table-contract-td table-contract-td-confirm p-${padding_num}`} style={{ textAlign: "left", backgroundColor: backgroundColor }}>
                            <QuantityInput auth={auth} age={age} is555={is555} max={quantityMax} value={quantity} quantityPreHandler={quantityPreHandler} quantityHandler={quantityHandler} disabled={disabled} lock={auth == "NA"} />
                        </td>
                    }
                    {showChangeDuration && (
                        <td className={`table-contract-td table-contract-td-confirm p-${padding_num}`} style={{ backgroundColor: backgroundColor }}>
                            {!needRecontract && (auth === "AP" || auth === "WT") && (
                                <DurationCell startDate={startDate} endDate={endDate} startDateHandler={startDateHandler} endDateHandler={endDateHandler} disabled={disabled} />
                            )}
                            {!disabled && needRecontract && (
                                <>
                                    <label className="text-danger">
                                        <input
                                            type="checkbox"
                                            className="mr-2"
                                            name="recontract"
                                            onChange={(e) => {
                                                recontractHandler(e.target.checked);
                                            }}
                                            checked={recontractEndDate ? true : false}
                                        />
                                        재계약
                                    </label>
                                </>
                            )}
                        </td>
                    )}
                </>
            )}
        </>
    );
};

const CommonAcceptCell = ({
    bizApp,
    age,
    quantity,
    auth,
    auth_org,
    authType,
    authTypeList,
    canChangeNoAuth = true,
    startDate,
    endDate,
    authHandler,
    authTypeHandler,
    startDateHandler,
    endDateHandler,
    quantityPreHandler,
    quantityHandler,
    disabled,
    is555,
    fold,
}) => {
    useEffect(() => {
        return () => {};
    }, [bizApp, age, auth, authType, quantity, startDate, endDate, fold]);
    if(!bizApp || bizApp.length < 1 || !bizApp.info) {
        return <></>;
    }
    const addCellQuantity = hasCellQuantity(bizApp);    // 단독 원아 수 표시 시
    if (is555) {
        return (
            <>
                <DisabledCell />
                {!fold && (
                    <>
                        {addCellQuantity && <DisabledCell />}
                    </>
                )}
            </>
        );
    }

    if (!auth) {
        return (
            <>
                <NullCell />
                {!fold && (
                    <>
                        {addCellQuantity && <NullCell />}
                    </>
                )}
            </>
        );
    }

    const backgroundColor = disabled ? tas4Style.color.background.disabled : tas4Style.color.background.normal.modal;
    return (
        <>
            <td className={`table-contract-td table-contract-td-accept p-${padding_num}`} style={{ textAlign: "left", backgroundColor: backgroundColor }}>
                <AgeSelect bizApp={bizApp.info} appId={bizApp.info.appId} age={age} approval={auth} approval_org={auth_org} canChangeNoAuth={canChangeNoAuth} authHandler={authHandler} disabled={disabled} />
            </td>
            {!fold && (
                <>
                    {addCellQuantity &&
                        <td className={`table-contract-td table-contract-td-accept p-${padding_num}`} style={{ textAlign: "left", backgroundColor: backgroundColor }}>
                            <QuantityInput auth={auth} age={age} is555={is555} value={quantity} quantityPreHandler={quantityPreHandler} quantityHandler={quantityHandler} disabled={disabled} lock={auth == "NA"} />
                        </td>
                    }
                    <td className={`table-contract-td table-contract-td-accept p-${padding_num}`} style={{ backgroundColor: backgroundColor }}>
                        {(auth === "AP" || auth === "WT") && (
                            <DurationCell startDate={startDate} endDate={endDate} startDateHandler={auth === "WT" ? startDateHandler : null} endDateHandler={endDateHandler} disabled={disabled} />
                        )}
                    </td>
                </>
            )}
        </>
    );
};

const PopupClassHeader = ({ idx, userId, list, setList }) => {
    useEffect(() => {
        return () => {};
    }, [idx, userId, list]);

    const removeAddedClass = () => {
        if (window.confirm("추가한 반을 삭제하시겠습니까?")) {
            list.splice(idx, 1);
            setList(list);
        }
    };
    return (
        <>
            {userId ? (
                <>{userId}</>
            ) : (
                <a className={"a-user-id"} onClick={removeAddedClass}>
                    <div style={{ width: "100%" }} className="">
                        <i class="fas fa-minus-circle" />
                    </div>
                </a>
            )}
        </>
    );
};

export default {
    Header: {
        Default: DefaultHeader,
        Add: AddTableHeader,
        RecontractConfirm: RecontractConfirmHeader,
    },
    UserIdViewCell: ContractUserIdViewCell,
    DateCell: DurationCell,
    PopupClassHeader: PopupClassHeader,
    QuantityInput: QuantityInput,
    DeviceSelect: DeviceSelect,
    UnionSelect: UnionSelect,
    ViewCell: CommonViewCell,
    CreateCell: CommonCreateCell,
    ConfirmCell: CommonConfirmCell,
    AcceptCell: CommonAcceptCell,
    func: {
        getBizAppMap: getBizAppMap,
        quantityPreHandler: quantityPreHandler,
        quantityHandler: quantityHandler,
        deviceHandler: deviceHandler,
        unionHandler: unionHandler,
        endDateHandler: endDateHandler,
        startDateHandler: startDateHandler,
        checkUnionUnbind: checkUnionUnbind,
        ageStr: AgeStr,
        getUnionId: getUnionId,
        getUnionInfo: getUnionInfo,
        getUnionName: getUnionName,
    },
    paddigClass: `p-${padding_num}`,
};
